import React from 'react';
import PropTypes from 'prop-types';

import { graphql, compose } from 'react-apollo';
import { logOutMutation } from 'apps/ask/mutations/log-out';

import { withUser } from '../contexts/user';

function UserSignOutLink({ className, user, logOutMutation }) {
  const handleSignOutClick = async (event) => {
    event.preventDefault();

    await logOutMutation({
      variables: {
        input: {
          void: ''
        }
      }
    });

    user.logOut();
  };

  return (
    <a className={className} onClick={handleSignOutClick}>Sign out</a>
  );
}

UserSignOutLink.propTypes = {
  className: PropTypes.string,
  user: PropTypes.object.isRequired,
  logOutMutation: PropTypes.func.isRequired,
};

export default compose(
  withUser,
  graphql(logOutMutation, {
    name: 'logOutMutation'
  })
)(UserSignOutLink);
